import { render, staticRenderFns } from "./OrdersFBMTableUserHead.vue?vue&type=template&id=4223d074&scoped=true"
import script from "./OrdersFBMTableUserHead.vue?vue&type=script&lang=js"
export * from "./OrdersFBMTableUserHead.vue?vue&type=script&lang=js"
import style0 from "./OrdersFBMTableUserHead.vue?vue&type=style&index=0&id=4223d074&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4223d074",
  null
  
)

export default component.exports